function TachoDaily() {
    /// <summary>
    /// This object does the complete handling of the Chart.Tacho.Template.vb. <br/>
    /// It creates a tachometer/gauge chart based on highcharts.<br/>
    /// <br/>
    /// As the tachometer is a half circle the positioning of the chart based on the given width/height is a bit tricky. 
    /// <br/>
    /// Author: ARF<br />
    /// Date: 30.9.2015<br />
    /// Copyright ©: EUDT GmbH 2015 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 20.10.2015                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
    // the following attributes got set in Tacho.Template.vb
    this.value = 0;
    this.caption = '';
    this.unit = '';
    this.min = 0;
    this.max = 0;
    this.range1 = {"from": 0, "to": 0,"color": "#000"}
    this.range2 = { "from": 0, "to": 0, "color": "#000" }
    this.range3 = { "from": 0, "to": 0, "color": "#000" }
    this.range4 = { "from": 0, "to": 0, "color": "#000" }

    // the following attributes get set based on the given width/height
    this.verticalPosition = "";
    this.verticalPositionLabel = 0;
    this.fontSizeData = "14px";
    this.fontSizeTicks = "15px";
    this.paneSize = 0;
   
}

TachoDaily.prototype = new vcTemplate();


TachoDaily.prototype.init = function () {
    /// <summary>
    /// First, this function calculates values for the proper handling of different heights/widths. <br/>
    /// Then, it inits the chart. 
    /// </summary>
    var me = this;
    var min;

    //set the position based on the relation between the width/height
   
    if (me.isImmission === false) {
       
        if (me.signalColor.length > 0) {
            this.range1.color = me.signalColor;
            this.range2.color = me.signalColor;
            this.range3.color = me.signalColor;
        } else {

            if (typeof (window._tacho_colors) !== "undefined") {
                if (window._tacho_colors.length >= 4) {
                    this.range1.color = window._tacho_colors[0];
                    this.range2.color = window._tacho_colors[1];
                    this.range3.color = window._tacho_colors[2];
                    this.range4.color = window._tacho_colors[3];
                }
                if (window._tacho_colors.length === 1) {

                    min = this.range1.from;
                    this.range1.to = min;
                    this.range2.from = min;
                    this.range2.to = min;
                    this.range3.from = min;
                    this.range3.to = min;
                    this.range4.from = min;
                    this.range1.color = window._tacho_colors[0];
                    this.range2.color = window._tacho_colors[0];
                    this.range3.color = window._tacho_colors[0];
                    this.range4.color = window._tacho_colors[0];

                }

            }
        }
    }

    this.innerRadius = "100%";
    this.outerRadius = "75%";
   

    this.verticalPosition = this.width / this.height;
    this.verticalPosition = 1.7 / this.verticalPosition;
    this.verticalPosition = parseInt(100 / this.verticalPosition, 10);

    //fix the label positions
    this.verticalPositionLabel = parseInt(this.height * -0.15, 10);

    this.paneSize = this.width - parseInt(this.width * 0.15, 10);
  
    //adopt the settings for different sizes
    

    if (this.height >= 180 && this.height < 250) {
            this.fontSizeTicks = "12px";
            this.verticalPosition = parseInt(this.verticalPosition * 0.9, 10);
            this.verticalPositionLabel = parseInt(this.verticalPositionLabel * 0.3, 10);
        }

        if (this.height > 500) {
            this.fontSizeData = "36px";
            this.fontSizeTicks = "28px";
            this.verticalPosition = parseInt(this.verticalPosition * 0.87, 10);
        }
 
    if (me.mobile) {
        this.verticalPosition = parseInt(this.verticalPosition * 0.95, 10);
        this.verticalPositionLabel = parseInt(this.verticalPositionLabel * 0.3, 10);
       
        if (this.width > 600) {
                this.fontSizeData = "25px";
        } else {

                if (this.width > 410) {
                    this.fontSizeData = "15px";
                    this.fontSizeTicks = "15px";
                    this.verticalPosition = parseInt(this.verticalPosition * 1.02, 10);
                } else {
                    this.fontSizeData = "9px";
                    this.fontSizeTicks = "8px";
                    this.verticalPosition = parseInt(this.verticalPosition * 1.08, 10);
                }

            }
           
          
        }
  

    //init the highcart
    this.visual.highcharts({
        chart: {
            type: 'gauge',
            plotBackgroundColor: null,
            plotBackgroundImage: null,
            plotBorderWidth: 0,
            plotShadow: false

        },
        exporting: {enabled:false},
        credits: { enabled: false },
        title: "",
        tooltip: { enabled: false },
        pane: {
            startAngle: -75,
            endAngle: 75,
            background: null,
            center: ['50%', this.verticalPosition + '%'],
            //center: ['50%', '100'],
            size: this.paneSize
        },

        plotOptions: {
            gauge: {
                dial: {
                    backgroundColor: "#72828b",
                    baseWidth: 15,
                    borderWidth: 0,
                    topWidth: 2,
                    radius: "90%",
                    baseLength: "70%",
                    rearLength: "-65%"

                },
                pivot: { radius: 0 },
                dataLabels: {
                    y: this.verticalPositionLabel,
                    borderWidth: 0,
                    style: { fontSize: this.fontSizeData },
                    formatter: function () { return "<div style='text-align:center'>" + Highcharts.numberFormat(this.y, me.decimalPoints, ",", ".") + " " + "<br/><span style='font-size:smaller'>" + me.caption + "</span></div>" },
                    useHTML: true
                }
            }
        },

        // the value axis
        yAxis: {
            min: this.min,
            max: this.max,
            minorTickInterval: 'auto',
            minorTickWidth: 0,
            minorTickPosition: 'outside',
            minorTickColor: '#333333',
            tickWidth: 0,
            tickPosition: 'outside',
            tickColor: '#333333',
            tickInterval: this.tickInterval,
            lineWidth:0,
            labels: {
                x: 0,
                y:0,
                distance: 8,
                rotation: 'auto',
                style: { fontSize: this.fontSizeTicks },
                formatter: function () {
                    if (me.fixTickInterval) {
                        return this.value;
                    } else {
                       
                        if (me.max < 100) {
                            return this.value;
                        } else {
                            if (me.max < 1000) {
                                return this.value;
                            } else {
                                return Highcharts.numberFormat(parseInt(Highcharts.numberFormat(this.value / 100, 0, ",", ""), 10) * 100, 0, ",", ".");
                            }
                        }
                        
                    }
                }

            },
            title: "",
            plotBands: [
                {
                    from: parseInt(this.range1.from,10),
                    to: parseInt(this.range1.to,10),
                    color: this.range1.color, // green
                    innerRadius: this.innerRadius,
                    outerRadius: this.outerRadius
                }, {
                    from: parseInt(this.range2.from, 10),
                    to: parseInt(this.range2.to, 10),
                    color: this.range2.color,  // yellow #ded711
                    innerRadius: this.innerRadius,
                    outerRadius: this.outerRadius
                }, {
                    from: parseInt(this.range3.from, 10),
                    to: parseInt(this.range3.to, 10),
                    color: this.range3.color, // red
                    innerRadius: this.innerRadius,
                    outerRadius: this.outerRadius
                }
                , {
                    from: parseInt(this.range4.from, 10),
                    to: parseInt(this.range4.to, 10),
                    color: this.range4.color, // red
                    innerRadius: this.innerRadius,
                    outerRadius: this.outerRadius
                }
            ]
        },

        series: [
        {
            name: this.caption,
            data: [this.value]
        }]

    });



}

